import { render, staticRenderFns } from "./SearchResponsesItemChatUser.vue?vue&type=template&id=2d9c1ae1&scoped=true"
import script from "./SearchResponsesItemChatUser.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItemChatUser.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItemChatUser.vue?vue&type=style&index=0&id=2d9c1ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c1ae1",
  null
  
)

export default component.exports